import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LtmsEventHandlerService {
  ltmsCustomEvents:any = {};
  data:any = null
  constructor() { }

  /**
   * Listen Event

    Fields:

        eventName - String - Required field - Name of event which is being listened
        callback - function - Required
        child  -  String - optional - child of an event

    Example:

    LtmsEventListener.on(eventName, function(data){});
    LtmsEventListener.on(eventName, function(data){}, child);
   * @param event 
   * @param fn 
   * @param child 
   */
  listen(eventName:string, callback:any, child?:string) {
    try {
      if (!this.ltmsCustomEvents[eventName]) {
        this.ltmsCustomEvents[eventName] = { default: [], childs: {} };
      }
      if (!child) {
        this.ltmsCustomEvents[eventName].default.push(callback);
      } else {
        if (this.ltmsCustomEvents[eventName].childs[child]) {
          this.ltmsCustomEvents[eventName].childs[child].push(callback);
        } else {
          this.ltmsCustomEvents[eventName].childs[child] = this.ltmsCustomEvents[eventName].childs[child] || [];
          this.ltmsCustomEvents[eventName].childs[child].push(callback);
        }
      }
    } catch (e) {
      console.log('Error occured on initializing event listner.', e);
    }
  }


  /**
   * Emit Event:

    Fields:

        eventName - String - Required - Name of the Event
        Data (data cdould be of any type) - Optional - You can pass any type of data which you need to update or access
        child  -  String - optional - child of an event

    Example:
    
        LtmsEventListener.fire(eventName, data);
        LtmsEventListener.fire(eventName, data, child);

   * @param type 
   * @param data 
   * @param child 
   */
  emit(eventName:string, data?:any, child?:string) {
    try {
      var eventData = {
        data: data ? (this.data = data) : null,
        event: eventName
      }

      if (this.ltmsCustomEvents[eventName] && this.ltmsCustomEvents[eventName].default && !child) {
        for (var idx = 0; idx < this.ltmsCustomEvents[eventName].default.length; idx++) {
          this.ltmsCustomEvents[eventName].default[idx](eventData);
        }
      }

      if (this.ltmsCustomEvents[eventName] && this.ltmsCustomEvents[eventName].childs && !child) {
        for (var childEvent in this.ltmsCustomEvents[eventName].childs) {
          for (var idx = 0; idx < this.ltmsCustomEvents[eventName].childs[childEvent].length; idx++) {
            this.ltmsCustomEvents[eventName].childs[childEvent][idx](eventData);
          }
        }
      }

      if (child) {
        if (this.ltmsCustomEvents[eventName] && this.ltmsCustomEvents[eventName].childs && this.ltmsCustomEvents[eventName].childs[child]) {
          for (var idx = 0; idx < this.ltmsCustomEvents[eventName].childs[child].length; idx++) {
            this.ltmsCustomEvents[eventName].childs[child][idx](eventData);
          }
        }
      }
    } catch (e) {
      console.log('Error occured on fire event listner.', e);
    }
  }
/**
 *  Remove Event

    Fields:

        eventName - string - Required field - Name of the event which is being removed.
        child  -   String - Optional field - Name of child event

    Example:

    LtmsEventListener.remove(eventName);    
    LtmsEventListener.remove(eventName, child);  
 * @param type 
 * @param child 
 */
  remove(eventName:string, child?:string) {
    try {
      if (this.ltmsCustomEvents[eventName]) {
        if (child) {
          if (this.ltmsCustomEvents[eventName].childs[child]) {
            delete this.ltmsCustomEvents[eventName].childs[child];
          }
          if (Object.keys(this.ltmsCustomEvents[eventName].childs).length == 0 && this.ltmsCustomEvents[eventName].default.length == 0) {
            delete this.ltmsCustomEvents[eventName];
          }
        } else {
          delete this.ltmsCustomEvents[eventName];
        }
      }
    } catch (e) {
      console.log('Error occured on remove event listner.', e)
    }
  };
}


